import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import Services from "./components/Services";
import Industries from "./components/Industries";
import CaseStudies from "./components/CaseStudies";
import Testimonials from "./components/Testimonials";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <WhatsAppButton />
      <Header />
      <main>
        <Hero />
        <Stats />
        <div id="services">
          <Services />
        </div>
        <div id="industries">
          <Industries />
        </div>
        <div id="case-studies">
          <CaseStudies />
        </div>
        <div id="testimonials">
          <Testimonials />
        </div>
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
